import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../../Controls/TextBoxControl"
import GridControl from "../../../../Controls/GridControl"
import Accordion from 'react-bootstrap/Accordion';
import ShowOwnerResidentialInfo from "../../../../Controls/ShowOwnerResidentialInfo"
import ShowFilesReviewAbstractList from "../../../../Controls/ShowFilesReviewAbstractList"

import { 
	GetLocal,
	FetchService,
	Base64Type
} from "../../../../Base/BaseControl";
import { EmployeeSessionCheckFetch } from '../../../../Base/BasePageEmployee';

export default function Index(props) {
	const [getServiceResult, setServiceResult] = useState(false);
	
    useEffect(() => {
        var inputValue = {
             session: GetLocal('EmployeeSession'),
			 requestNumber: GetLocal('RequestNumber')
        };
        EmployeeSessionCheckFetch("Employee/Urbanization/Review/ShowCorrespondenceReview", inputValue, ShowServiceResultSuccess);
    }, []);	
	
    const ShowServiceResultSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult);
    }		
	
    return (
        <div> 
			<ShowOwnerResidentialInfo Session={GetLocal('EmployeeSession')}/>
			<ShowFilesReviewAbstractList/>
			{getServiceResult ? <div>
			<GridControl
				data={Object.keys(getServiceResult).length > 0 && getServiceResult.CorrespondenceInfoList}
				customHeaders={{
					"LetterTitle": "نوع نامه",
					"LetterNumber": "شماره نامه",
					"LetterDate": "تاریخ نامه",
					"RequestLetterNumber": "شماره نامه پاسخ",
					"RequestLetterDate": "تاریخ نامه پاسخ",
					"RegistrationLetterNumber": "شماره ثبت پاسخ",
					"RegistrationLetterDate": "تاریخ ثبت پاسخ",
					"Description": "توضیحات",
				}}		
			/>				
			<br/>	
			<GridControl
				data={Object.keys(getServiceResult).length > 0 && getServiceResult.DocumentActionInfoList}
				customHeaders={{
					"ActionIdentifierTitle": "نوع نامه",
					"User": "نام کابر",
					"ActionDate": "زمان قدیم",
					"ActionTitle": "نحوه اقدام",
					"SerialNumber": "شماره نامه",
					"DocumentTitle": "آخرین اقدام پروانه"
				}}		
			/>				
        </div>
		:
			<div className="alert alert-danger text-center">موردی یافت نشد.</div>
		}
		</div>
    );
}
